var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input } from '../../components';
import styles from './style.module.scss';
import { useHttp } from '../../hooks/useHttp';
import { toast } from 'react-toastify';
import { AppContext } from '../../hooks/context';
const AuthPage = () => {
    const { t } = useTranslation();
    const { request, loader } = useHttp();
    const { setAuth } = React.useContext(AppContext);
    const [form, setForm] = React.useState({
        login: '',
        password: '',
    });
    const change = (e) => {
        setForm(Object.assign(Object.assign({}, form), { [e.target.name]: e.target.value.trim() }));
    };
    const loginApi = (e) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            e.preventDefault();
            if (form.login.length && form.password.length) {
                const res = yield request('/auth/login', 'POST', {
                    login: form.login,
                    password: form.password,
                });
                toast[res.type](res.message);
                if (res.auth) {
                    const { id_avn_user, id_user, id_role } = res.data;
                    return setAuth ? setAuth({ id_avn_user, id_user, id_role, isAuth: res.auth }) : null;
                }
                return;
            }
            toast.warn(t('warnInput'));
        }
        catch (e) { }
    });
    return (_jsx("div", Object.assign({ className: "d-flex align-items-center justify-content-center", style: { height: 'calc(100vh - 60px)' } }, { children: _jsx("div", Object.assign({ className: styles.form }, { children: _jsxs("form", { children: [_jsx("h1", { children: t('auth') }), _jsx("div", Object.assign({ className: styles.auth_inputs }, { children: _jsx(Input, { value: form.login, change: change, id: "login", label: "\u041B\u043E\u0433\u0438\u043D", type: "text", placeholder: t('enterLogin'), width: "300px", name: "login", title: "" }) })), _jsx("div", Object.assign({ className: styles.auth_inputs }, { children: _jsx(Input, { value: form.password, change: change, id: "password", label: t('password'), type: "password", placeholder: t('enterPassword'), width: "300px", name: "password", title: "" }) })), _jsx("div", Object.assign({ className: "d-flex justify-content-center mt-3" }, { children: _jsx(Button, { value: t('welcome'), isLoader: loader, disabled: loader, onClick: loginApi, icon: _jsx("i", { className: "fa-solid fa-key" }) }) }))] }) })) })));
};
export default AuthPage;
